import { useWeb3React } from "@web3-react/core";
import Modal from "components/Modal/Modal";
import { getNativeToken } from "config/tokens";
import { useChainId } from "lib/chains";
import { importImage } from "lib/legacy";
import { useState } from "react";
import icArrowSumary from 'img/lockMMY/arrow_down.svg';
import icArrowUp from 'img/lockMMY/up-arrow.svg';
import { MdArrowBack, MdArrowLeft, MdChevronLeft, MdClose } from "react-icons/md";
import mmyCircleLogo from 'img/lockMMY/mmy_circle_logo.svg';
import icTime from 'img/lockMMY/timer.svg';
import { formatAmount, parseValue } from "lib/numbers";
import { approveTokens } from "domain/tokens";
import useSWR from "swr";
import { contractFetcher } from "lib/contracts";
import { getContract } from "config/contracts";
import Token from "abis/Token.json";
import { ethers } from "ethers";
import useLockMMYLP from "hooks/useLockMMYLP";
const { AddressZero } = ethers.constants;
const ExtendLockModal = ({ visible, setIsVisible, userInfo, mmyLPBalance, setPendingTxns, connectWallet, tokenAllowance }) => {
  const monthTabs = [
    { type: 0, text: "1 month", apr: 1.447 },
    { type: 1, text: "3 months", apr: 1.447 },
    { type: 2, text: "6 months", apr: 1.447 },
    { type: 3, text: "12 months", apr: 1.447 },
  ]
  const [nativeValue, setNativeValue] = useState(0);
  const [currentLockType, setCurrentLockType] = useState(0)
  const [mmyValue, setMMYvalue] = useState(0);
  const [step, setStep] = useState(0);
  const [isApproving, setIsApproving] = useState(false);
  const { chainId } = useChainId();
  const { active, account, library } = useWeb3React()
  const nativeImage = importImage(`ic_${getNativeToken(chainId)?.symbol?.toLowerCase()}_24.svg`);
  const mmyImage = importImage(`ic_mmy_24.svg`);
  const [value, setValue] = useState(userInfo?.lockType || 0);
  const [duration, setDuration] = useState(0);
  const onChangLockType = async (lockType) => {
    setCurrentLockType(lockType);
  }
  const mmyLPAddess = getContract(chainId, "MMYLP")
  const FeeDistributionAddress = getContract(chainId, "MultiFeeDistribution");
  let amount = parseValue(value || 0, 18);
  const needApproval = FeeDistributionAddress !== AddressZero && tokenAllowance && amount && (tokenAllowance.eq(0) || amount.gt(tokenAllowance));
  const { setLock, setChangeDefaultLockType, setWithdraw, setAutoReLock, reLock } = useLockMMYLP(setPendingTxns)

  const isDisableLockBtn = () => {
    if (!value || value === 0) return true;
    if (value && parseValue(value, 18).gt(mmyLPBalance || 0)) return true;
    return false;
  }
  const onHandleLock = async () => {
    await setLock(parseValue(value, 18), currentLockType)
    setValue(0)
  }
  return (
    <Modal
      isVisible={visible}
      className="extend-lock-modal"
      setIsVisible={() => setIsVisible(false)}
      label={`Extend Lock MMY-LP tokens`}
    >
      <div className="extend-in-container">
        <div className='lock-inside-content'>
          <div className='input-container'>
            <div className='title-container'>
              <div className='title'>Lock</div>
              <div className='max-amount cursor-pointer' onClick={() => setValue(formatAmount(mmyLPBalance || 0, 18, 18, false))}>Max: {formatAmount(mmyLPBalance || 0, 18, 4, true)}</div>
            </div>
            <div className='input-content'>
              <input placeholder='0.0' type='number' value={value} onChange={e => setValue(e.target.value)} />
              <div className='token-info'>
                <button className='App-button-option btn-max'>Max</button>
                <img alt='' src={mmyCircleLogo} /> MMY-LP
              </div>
            </div>
          </div>
          <div className='input-container' style={{ marginTop: '8px' }}>
            <div className='title-container'>
              <div className='title'>Lock for</div>
              <div className='max-amount cursor-pointer'>7days - 4years</div>
            </div>
            <div className='input-content'>
              <input placeholder='0.0' type='number' value={duration} onChange={e => setDuration(e.target.value)} />
              <div className='token-info'>
                <img alt='' src={icTime} /> Days
              </div>
            </div>
          </div>

          <div className='default-lock-container'>
            <div className='months-container'>
              {monthTabs.map(item => (
                <div
                  onClick={() => onChangLockType(item.type)}
                  key={item.type} className={`month-tab ${currentLockType === item.type ? 'month-tab-active' : ''}`}>{item.text}</div>
              ))}
            </div>
            <div className='arrow-container'>
              <img alt='' src={icArrowSumary} />
            </div>
            <div className='summary-container'>
              <div className='title'>Summary after extends</div>
              <div className='sumary-content'>
                <div className='title'>Est. current veMMY-LP</div>
                <div className='value green-value'>100 <span className="open">(<img alt="" src={icArrowUp}/> <span className="green-value">10</span>)</span></div>
              </div>
              <div className='sumary-content'>
                <div className='title'>MMY-LP locked</div>
                <div className='value'>100 <span className="open">(<img alt="" src={icArrowUp}/> <span className="green-value">20</span>)</span></div>
              </div>
              <div className='sumary-content'>
                <div className='title'>Locked until</div>
                <div className='value'>02/23/2023 07:00 UTC <span className="open">(<img alt="" src={icArrowUp}/> <span className="green-value">20d</span>)</span></div>
              </div>
            </div>
            <div className='action-buttons'>
              {
                account ? needApproval ? <button className='App-button-option'
                  onClick={() => approveTokens({
                    setIsApproving,
                    library,
                    tokenAddress: mmyLPAddess,
                    spender: FeeDistributionAddress,
                    chainId,
                  })}
                >Approve</button>
                  : <button className='App-button-option'
                    onClick={onHandleLock}
                    disabled={isDisableLockBtn()}>Extend Lock</button>
                  : <button className='App-button-option' onClick={() => connectWallet()}>Connect Wallet</button>
              }
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
export default ExtendLockModal;
